// extracted by mini-css-extract-plugin
export var content = "styles-module--content--2SO9F";
export var desktop = "1340px";
export var giant = "2200px";
export var grid = "styles-module--grid--npyFD";
export var gridItem = "styles-module--gridItem--M+2Lc";
export var gridItemContent = "styles-module--gridItemContent--ZZ8os";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";